import "../../Subbundle.css";
import "./LinearSearch.css";
import React from "react";
import { Link } from "react-router-dom";

import AppleLogo from "../../../../Images/CompanyLogos/Apple.PNG";
import GoogleLogo from "../../../../Images/CompanyLogos/Google.PNG";
import TeslaLogo from "../../../../Images/CompanyLogos/Tesla.PNG";
import IBMLogo from "../../../../Images/CompanyLogos/IBM.PNG";
import InstagramLogo from "../../../../Images/CompanyLogos/Instagram.PNG";
import MicrosoftLogo from "../../../../Images/CompanyLogos/Microsoft.PNG";
import TwitterLogo from "../../../../Images/CompanyLogos/Twitter.PNG";
import SnapchatLogo from "../../../../Images/CompanyLogos/Snapchat.PNG";
import SpotifyLogo from "../../../../Images/CompanyLogos/Spotify.PNG";
import CSCultLogo from "../../../../Images/NewLogo.png";

let gif1 =
	"https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.tutorialspoint.com%2Fdata_structures_algorithms%2Fimages%2Flinear_search.gif&f=1&nofb=1";
let code1 =
	"https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fimage.slidesharecdn.com%2Flinearsearchalgorithm-131212155548-phpapp01%2F95%2Flinear-search-algorithm-5-638.jpg%3Fcb%3D1386863958&f=1&nofb=1";
let code2 =
	"https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fd2vlcm61l7u1fs.cloudfront.net%2Fmedia%252F403%252F403c0769-09d6-4e3b-aca2-62bc89c00c81%252FphpGILHcC.png&f=1&nofb=1";

var ctr = 0;

class CompanyBlock extends React.Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick() {
		let e1 = document.getElementById(this.props.companyID);
		e1.style.display = "block";

		let e2 = document.getElementById(this.props.companyID + "_div");
		e2.style.backgroundColor = "white";

		if (e1.id == "Snapchat") {
			document.getElementById("found-header").style.display = "block";
			for (let i = 0; i < 10; i++) {
				document.getElementById(
					companyIDs[i] + "_div"
				).style.backgroundColor = "white";
				document.getElementById(companyIDs[i]).style.display = "block";
			}
		}
	}

	render() {
		return (
			<div
				id={this.props.companyID + "_div"}
				onClick={this.handleClick}
				className="companyBlock"
			>
				<img
					id={this.props.companyID}
					className="companyLogo"
					style={{ width: "50px", height: "50px" }}
					src={this.props.companyLogo}
				/>
			</div>
		);
	}
}

let companyArray = [];
let companyLogos = [
	AppleLogo,
	GoogleLogo,
	TeslaLogo,
	IBMLogo,
	InstagramLogo,
	MicrosoftLogo,
	TwitterLogo,
	SnapchatLogo,
	SpotifyLogo,
	CSCultLogo,
];
let companyIDs = [
	"Apple",
	"Google",
	"Tesla",
	"IBM",
	"Instagram",
	"Microsoft",
	"Twitter",
	"Snapchat",
	"Spotify",
	"CSCult",
];

for (let i = 0; i < 10; i++) {
	companyArray.push(
		<CompanyBlock companyID={companyIDs[i]} companyLogo={companyLogos[i]} />
	);
}

export default class LinearSearch extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0);
		document.title = "Linear Search | Searching Bundle";
	}

	render() {
		return (
			<main>
				<h1 style={{textAlign: 'center', fontFamily: 'Gilroy', textDecoration: 'underline', fontSize: '2rem'}}><Link to="/">Go to Home</Link></h1>
				<div className="subbundle-main">
					<h1>Linear Search</h1>
					<p>
						<b>Linear search</b> is a type of searching algorithm
						that uses the linear approach in searching an element,
						generally in an array. It goes element by element in the
						certain data structure to find the element.
					</p>
					<p>
						It has a complexity of <code>O(n)</code>, which means it
						goes through N elements in the worst case scenario.
					</p>
					<p>
						This kind of search algorithm works best for data
						structures with less elements. It doesn't require us to
						sort the data structure by order, in order to search,
						like binary search requires.
					</p>
					<img id="ls-gif1" src={gif1} />
					<span>Linear Search Animation</span>
					<p>
						Now, there are two ways to implement a linear search
						during programming. You can either use an iterative
						approach, going step-by-step increasingly; or you can go
						the recursive way, by calling the same function with
						change in parameters.
					</p>
					<img
						id="ls-code1"
						src={code1}
						title="Iterative Linear Search"
					/>
					<span>Iterative Linear Search</span>
					<br />
					<img
						id="ls-code2"
						src={code2}
						title="Recursive Linear Search"
					/>
					<span>Recursive Linear Search</span>
					<hr />
					<h1>GAME TIME!</h1>
					<div className="subbundle-game-container">
						<h1
							style={{
								textAlign: "center",
								fontFamily: "Poppins",
							}}
						>
							Given below is an array of various company logos
							that are hidden. Find the Apple logo by starting
							from the first element, and step-by-step clicking on
							the next element until you find the{" "}
							<span style={{ color: "yellow" }}>Snapchat</span>{" "}
							Logo.
						</h1>
						<h1
							style={{
								fontSize: "3rem",
								textAlign: "center",
								fontFamily: "Poppins",
								color: "yellow",
								display: "none",
							}}
							id="found-header"
						>
							YOU FOUND Snapchat!
						</h1>
						<div className="ls-company-array">{companyArray}</div>
					</div>
					<div className="next-previous-div">
						<Link to="/games/searching/binary">
							<span>
								Next{">"} <b>Binary Search</b>
							</span>
						</Link>
					</div>
				</div>
			</main>
		);
	}
}
